
import Vue from "vue";
import Search from "~/entities/Search";

export default Vue.extend({
  name: "RecentSearch",
  model: {
    prop: "search",
  },
  props: {
    search: {
      required: true,
      type: Search,
    },
    index: Number,
  },
  data() {
    return {
      Holidays: [] as any,
    };
  },
  computed: {
    shipDate(): any {
      return this.search &&
        this.search.selectedRateSpeedIndex &&
        this.search.selectedRateSpeedIndex.length &&
        this.search.selectedRateSpeed &&
        this.search.selectedRateSpeed.length
        ? this.formatDate(
            ((this.search.selectedRateSpeed as any)[0] as any).ship,
            ((this.search.selectedRateSpeed as any)[0] as any).upsTransitDays
          )
        : undefined;
    },

    deliveryDate(): any {
      return this.search &&
        this.search.selectedRateSpeedIndex &&
        this.search.selectedRateSpeedIndex.length &&
        this.search.selectedRateSpeed &&
        this.search.selectedRateSpeed.length
        ? this.formatDate(
            ((this.search.selectedRateSpeed as any)[0] as any).ship,
            ((this.search.selectedRateSpeed as any)[0] as any).transitDays
          )
        : undefined;
    },

    tripType() {
      if (this.search && this.search.trips && this.search.trips.length) {
        if (this.search.trips.length == 2) {
          return "Round-trip";
        }
        if (this.search.trips.length > 2) {
          return "Multi-city";
        }
      }

      return "One-Way";
    },
  },

  methods: {
    forgetSearch(): void {
      this.$emit("searchAbandoned", { index: this.index });
    },
    retakeSavedSearch(): void {
      this.$emit("searchResumed", { index: this.index, search: this.search });
    },
    dateToISO(date: any): any {
      if (typeof date === "string" || date instanceof String) {
        date = new Date(date as string);
      }
      if (date instanceof Date) {
        let offsetMs = date.getTimezoneOffset() * 60 * 1000;
        let msLocal = date.getTime() - offsetMs;
        let dateLocal = new Date(msLocal);
        let iso = dateLocal.toISOString();
        let isoLocal = iso.slice(0, 10);
        return isoLocal;
      }
      return false;
    },
    getToday(): any {
      return this.dateToISO(new Date());
    },
    formatDate(date: any, daysDelta = 0): any {
      if (typeof date === "string" || date instanceof String) {
        date = new Date(date as string);
      }
      if (daysDelta) {
        let increment, skips;
        if (!date) {
          return "";
        }
        let auxDate = new Date(date);
        for (
          increment = 0, skips = 0;
          increment < daysDelta && skips < 31;
          auxDate.setDate(auxDate.getDate() + 1)
        ) {
          if ((this as any).getDisabledDates(auxDate)) {
            skips++;
          } else {
            increment++;
          }
          if (increment == daysDelta) break;
        }
        date = new Date(auxDate.getTime());
      }
      let formattedDate = date?.toLocaleDateString("en-us", {
        year: "numeric",
        weekday: "short",
        month: "short",
        day: "numeric",
        timeZone: "utc",
      });
      return formattedDate ? formattedDate : date;
    },
    getDisabledDates(date: any): any {
      if (typeof date === "string" || date instanceof String)
        date = new Date(date as string);
      if (!(date.getDay() % 6)) return true;
      if ((this as any).isBeforeToday(date)) return true;
      return (this as any).isADayOff(date);
    },
    isADayOff(date): boolean {
      //this method will replace (this as any).Holidays.isAHoliday
      //for this to work more efficiently, we will have to store the response from the soon to be endpoint in
      //the store, because we just can't be requesting days off every time a date need to be checked.
      //but for now, we have a fixed array of holidays for 2023.
      if ((this as any).Holidays && (this as any).Holidays.length < 1) {
        (this as any).Holidays = [
          //today I learned that in this particular form of the Date constructor, the months start at 0 for no reason, while the other components don't.
          new Date(2023, 1 - 1, 1),
          new Date(2023, 1 - 1, 2),
          new Date(2023, 5 - 1, 29),
          new Date(2023, 7 - 1, 4),
          new Date(2023, 9 - 1, 4),
          new Date(2023, 11 - 1, 23),
          new Date(2023, 12 - 1, 25),
          new Date(2024, 1 - 1, 1),
        ];
      }
      for (let index = 0; index < (this as any).Holidays.length; index++) {
        if ((this as any).Holidays[index].getTime() === date.getTime()) {
          return true;
        }
      }
      return false;
    },
    // TODO: this function is repeated in many places, need to be in a service / package / store, whatever is best practice in VUE I did refactor of these functions in Costs.vue
    isBeforeToday(date: any): any {
      if (typeof date === "string" || date instanceof String) {
        date = new Date(date as string);
      }
      let today = (this as any).getToday();
      date = (this as any).dateToISO(date);
      return date < today;
    },
  },
});
